import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import "./RiskAnalytics.scss";
import { withTranslation } from "react-i18next";
import { Collapse, OverlayTrigger, Table } from "react-bootstrap";
import { BiPencil } from "react-icons/bi";
import Utils from "../../../core/utilities/Utils";
import nodataimg from "../../../images/nodatafound.png";
import StandardService from "../../../core/service/StandardService";
import { currentYear, startYear, Months } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import { BsXSquare } from "react-icons/bs";
import { toast } from "react-toastify";
import CompanyService from "../../../core/service/CompanyService";
import { BiChevronDown, BiGitMerge, BiExport } from "react-icons/bi";
import { useNavigate } from "react-router";

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import RiskAnalyticsService from "../../../core/service/RiskAnalyticsService";
import { saveAs } from 'file-saver';
import API_ROUTES, { BASE_URL } from "../../../core/constants/api";
import { RegulationContext } from "../../../App";



export const baseURL = BASE_URL;

const RiskAnalytics = ({ t }) => {
    const [maintabledata, setMainTableData] = useState([]);
    const [socialtabledata, setSocialTableData] = useState([]);
    const [environmenttabledata, setEnvironmentTableData] = useState([]);
    const [governancetabledata, setGovernanceTableData] = useState([]);
    const [standardslist, setStandardsList] = useState([]);
    const [standardchoosed, setStandardChoosed] = useState(null);
    const [frequency, setFrequency] = useState("");
    const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
    const [frequencymonth, setFrequencyMonth] = useState("01");
    const [frequencyparam, setFrequencyParam] = useState(null);
    const [iseditable, setIsEditable] = useState(false);
    const [senddatapoints, setSendDataPoints] = useState([]);
    const [categorydata, setCategoryData] = useState([]);
    var data = JSON.parse(localStorage.getItem("authority"));
    const companyid = data?.profile?.company?.id;
    const optionsMonth = Months({ t });
    const [dsList, setDsList] = useState([]);
    const [shown, setShown] = useState(false);
    const [currentDs, setCurrentDs] = useState([]);
    const navigate = useNavigate();
    var dataLS = localStorage.getItem('selectedobj');
    var dataLSParsed = null;
    const [matricdata, setMatricData] = useState([]);
    const [metricchoosed, setMetricChoosed] = useState("");
    const [metricdetails, setMetricDetails] = useState([]);
    const [totalconsumption, setTotalConsumption] = useState("");
    const stdName = localStorage.getItem('stdName');
    const [metricname, setMetricName] = useState("");
    const [metricdetailsdata, setMetricDetailsData] = useState([]);
    const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);

    useEffect(() => {
        setFrequency(glbRegulation.frequency);
        setStandardChoosed(glbRegulation.id);

    }, [glbRegulation.id])
    useEffect(() => {
        setSendDataPoints([]);
        setFrequencyMonth("01");
        getSubscriptions();
        getCategory();
    }, [standardchoosed]);
    useEffect(() => {
        if (standardchoosed && annualyear && frequencymonth) {
            getMetricData(annualyear, frequencymonth);
        }
    }, [standardchoosed, annualyear, frequencymonth]);

    useEffect(() => {
        if (dataLS !== '' && dataLS !== undefined && dataLS !== null) {
            dataLSParsed = JSON.parse(dataLS);
            setStandardChoosed(dataLSParsed.standardchoosed);
            setAnnualYear(dataLSParsed.annualyear);
            setFrequencyMonth(dataLSParsed.frequencymonth);
            localStorage.setItem('selectedobj', '');
            dataLS = '';

        }
    }, [dataLS]);

    useEffect(() => {
        if (standardslist.length > 0 && dataLSParsed !== '' && dataLSParsed !== undefined && dataLSParsed !== null) {
            changeStandard(dataLSParsed.standardchoosed, false);
        }
    }, [standardslist, dataLSParsed]);

    const getSubscriptions = async (e) => {
        if (companyid) {
            let subType = "S";
            CompanyService.getCompanySubscriptions(companyid, subType)
                .then((response) => {
                    let resRegulations = response?.data?.regulations;
                    setStandardsList([...resRegulations]);
                })
                .catch((error) => { });
        }
    };


    const getCategory = async (e) => {
        StandardService.getCategory()
            .then((response) => {
                setCategoryData([...response.data]);
            })
            .catch((error) => { });
    };

    const renderMetric = () => {
        const options = [];

        for (let index = 0; index < matricdata.length; index++) {
            const element = matricdata[index];
            options.push(
                <option value={element.metricId} key={element.metricName}>
                    {element.metricName}
                </option>
            );
        }
        if (standardchoosed && frequencymonth) {

            return (

                <select
                    id="mySelect"
                    className="form-select"
                    required
                    onChange={(e) => {
                        setMetricChoosed(e.target.value);
                        getMetricDetails(frequencymonth, e.target.value);
                        setMetricName(e.target.key);
                    }}
                    value={metricchoosed}
                >   <option value="">Select</option>
                    {options}
                </select>

            )

        }


    }

    const getMetricData = async (annualYearDat, freqMonth) => {
        var frequencyParam = null;
        frequencyParam = annualYearDat + "-" + freqMonth + "-01";
        setFrequencyParam(frequencyParam);
        RiskAnalyticsService.getMetricData(standardchoosed, frequencyParam)
            .then((response) => {
                let arrayDP = response.data.metrics;
                setMatricData(arrayDP);
                // const renderMetric = () => {
                //     const options = [];
                //     for (let index = 0; index < arrayDP.length; index++) {
                //         const element = arrayDP[index];
                //         options.push(
                //             <option value={element.metricId} >
                //               {element.metricName}
                //             </option>
                //           );
                //     }
                //   }

            })
            .catch((error) => {
                setMainTableData([]);
            });
    };

    const getMetricDetails = async (freqMonth, option) => {
        var frequencyParam = null;
        frequencyParam = annualyear + "-" + freqMonth + "-01";
        setFrequencyParam(frequencyParam);
        console.log(frequencyParam);
        RiskAnalyticsService.getMetricDetailsTable(standardchoosed, option, frequencyParam)
            .then((response) => {
                let arrayDP = response.data;
                setMetricDetailsData(arrayDP);
                console.log(metricdetailsdata);
                setMetricDetails(arrayDP.dataPoints);
                setTotalConsumption(arrayDP.totalConsumption);
            })
            .catch((error) => {
                setMainTableData([]);
            });
    };

    const renderMetricTable = () => {


        if (standardchoosed && frequencymonth && metricchoosed) {
            return (
                <div className="DataPointsMetrics mt-2">

                    {/* <div className="List_header">
                        <h5 className="">{t("Standards.label")}</h5>

                    </div> */}
                    {/* <div className='Sub_headerBox mb-2'>
                        <ul>
                            <li>Standard : <b>{stdName}</b></li>
                            <li>Category : <b>categoryName</b></li>
                            <li>Topic : <b>topicName</b></li>
                            <li>Metric : <b>{metricname}</b></li>
                            <li>Equation : <b>equationData</b></li>
                        </ul>
                    </div> */}
                    <div className=" card List_table-card01 ">
                        <Table responsive className='m-0' bordered>
                            <thead>
                                <tr>
                                    <th className="">Datapoint</th>
                                    <th className="">Unit</th>
                                    <th className="">Combined</th>
                                    <>{metricdetails.length && metricdetails[0].branches.map((item, index) => (
                                        <><th>{item.name}
                                            {/* <span>
                                                {!iseditable ? (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(t("Edit.label"))}
                                                    >
                                                        <span>
                                                            <BiPencil
                                                                className="cursor"
                                                                onClick={() => setIsEditable(!iseditable)}
                                                            />
                                                        </span>
                                                    </OverlayTrigger>
                                                ) : (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={Utils.renderTooltip(t("CancelEdit.label"))}
                                                    >
                                                        <span>
                                                            <BsXSquare
                                                                className="cursor"
                                                                onClick={() => setIsEditable(!iseditable)}
                                                            ></BsXSquare>{" "}
                                                        </span>
                                                    </OverlayTrigger>
                                                )}
                                            </span> */}
                                        </th>
                                        </>
                                    ))}</>
                                </tr>
                            </thead>
                            <tbody>
                                {metricdetails.length && metricdetails.map((item, index) => (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>{item.unit}</td>
                                        <td>{item.combined}</td>
                                        <>
                                            {item.branches.length > 0 && item.branches.map((britem, brindex) => (
                                                <td>
                                                    <>
                                                        {iseditable ? (
                                                            <input
                                                                className="form-control"
                                                                id={brindex}
                                                                defaultValue={britem?.value}
                                                                name="value"
                                                            // onChange={updateFieldChanged(britem, item.id)}
                                                            // onKeyDown={handleKeyPress}
                                                            />
                                                        ) : (
                                                            <span>{britem.value}</span>
                                                        )}
                                                    </>
                                                </td>
                                            ))}
                                        </>

                                    </tr>

                                ))}
                                <tr>
                                    <td>Total Consumption</td>
                                    <td>{totalconsumption}</td>
                                    {/* <td className="d3">Total consumption is zero</td> */}
                                </tr>
                            </tbody>
                        </Table>
                        {/* {iseditable && (
                            <div className="p-2 text-center">
                                <button
                                    type="button"
                                    onClick={() => {
                                        submitBrDataPoint();
                                    }}
                                    className="btn btn-primary ms-2 px-4 sbmBtn"
                                >
                                    {t("Save.label")}
                                </button>
                                <button type="button" className="btn btn-primary ms-2 px-4 sbmBtn" onClick={handleBackBtn}>
                                    {t("Back.label")}
                                </button>
                            </div>
                        )} */}

                    </div>
                    {/* {!iseditable && (
                        <div className="p-2 text-center">
                            <button type="button" className="btn btn-primary ms-2 px-4 sbmBtn" onClick={handleBackBtn}>
                                {t("Back.label")}
                            </button>
                        </div>
                    )} */}
                </div>




            )
        }


    }
    // function download() {

    //     let params = {
    //         "key1": ["value1", "value2", "value3"],

    //         "key2": ["value4", "value5", "value6"]
    //     }
    //     // for (let index = 0; index < metricdetails.length; index++) {
    //     //     const element = metricdetails[index];
    //     //     let keyValuePair = [];
    //     //     keyValuePair.push({

    //     //     })
    //     // }

    //     RiskAnalyticsService.exportToExcel(params)
    //         .then((response) => {
    //             console.log(response);
    //             // const fileName = 'example.xlsx';
    //             // const byteArray = response.data;
    //             // const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    //             // // Create a download link
    //             // const downloadLink = document.createElement('a');
    //             // downloadLink.href = URL.createObjectURL(blob);
    //             // downloadLink.download = fileName;

    //             // // Append the link to the document body
    //             // document.body.appendChild(downloadLink);

    //             // // Trigger the download
    //             // downloadLink.click();

    //             // // Clean up
    //             // document.body.removeChild(downloadLink);
    //             // URL.revokeObjectURL(downloadLink.href);

    //             // KPIService.downloadFile(standardchoosed)
    //             //     .then((response) => {
    //             //         console.log(response);
    //             //         let blob = new Blob([response.data], { type: 'application/octet-stream' });
    //             //         const fileURL = window.URL.createObjectURL(blob);
    //             //         let link = document.createElement('a');
    //             //         link.href = fileURL;
    //             //         const fileName = standardslist.find(s => s.id === +standardchoosed)?.name;
    //             //         link.download = fileName ? `${fileName}-Template.xlsx` : `Template.xlsx`;
    //             //         link.click();
    //             //         link.remove();
    //             //     })
    //             //     .catch((error) => {
    //             //         console.log(error);
    //             //     });


    //             // const XLSX = require('xlsx');

    //             // // Assuming you have the byte array stored in a variable called 'byteArray'
    //             // const workbook = XLSX.read(response.data, { type: 'array' });

    //             // // Convert workbook to binary data
    //             // const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    //             // // Create a Blob from the binary data
    //             // const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    //             // console.log(excelBlob);
    //             // const downloadLink = document.createElement('a');
    //             // downloadLink.href = URL.createObjectURL(excelBlob);
    //             // downloadLink.download = 'data.xlsx';

    //             // // Append the link to the document body
    //             // document.body.appendChild(downloadLink);

    //             // // Simulate a click event on the link to start the download
    //             // downloadLink.click();

    //             // // Clean up
    //             // document.body.removeChild(downloadLink);

    //         })
    //         .catch((error) => {
    //             setMainTableData([]);
    //         });

    // }

    function download() {
        console.log(metricdetailsdata);
        let data = {};
        data = metricdetailsdata;
        // Create a HashMap-like object in JavaScript

        const dataPointHashMap = {

            DataPoint: [],

            Unit: [],

            Combined: []

        };

        data.dataPoints.forEach((dataPoint) => {

            // Extracted data points from the given data

            const dataPointName = dataPoint.name;

            const unit = dataPoint.unit;

            const combined = dataPoint.combined;



            // Add data points to the HashMap-like object

            dataPointHashMap.DataPoint.push(dataPointName);

            dataPointHashMap.Unit.push(unit);

            dataPointHashMap.Combined.push(combined);



            // Iterate over branches and add values to respective branch keys

            dataPoint.branches.forEach((branch) => {

                const branchName = branch.name;

                const branchValue = branch.value;



                if (!dataPointHashMap[branchName]) {

                    dataPointHashMap[branchName] = [];

                }



                dataPointHashMap[branchName].push(branchValue);

            });

        });

        console.log(dataPointHashMap);
        fetch(BASE_URL + '/cockpit/api/export/excel', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Add any other required headers
                Authorization: 'Bearer' + localStorage.getItem('accessToken')
            },
            body: JSON.stringify(dataPointHashMap),
        })
            .then(response => response.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = 'filename.xlsx';


                link.click();

                URL.revokeObjectURL(url);
            })
            .catch(error => {
                // Handle any errors
                console.error('Error:', error);
            });

    }



    const changeStandard = (e, isDropDown) => {
        var id = null;
        if (isDropDown) {
            id = e.target.value;
        } else {
            id = e;
        }

        setStandardChoosed(id);
        var filtered = standardslist.filter((x) => x.id == id);
        console.log('id', filtered[0].frequency)
        localStorage.setItem('stdName', filtered[0].name);
        setFrequency(filtered[0].frequency);
    };

    const changeMetric = (e, isDropDown) => {
        var id = null;
        if (isDropDown) {
            id = e.target.value;
        } else {
            id = e;
        }

        setMetricChoosed(id);
        var filtered = standardslist.filter((x) => x.id == id);
        console.log('id', filtered[0].frequency)
        localStorage.setItem('stdName', filtered[0].name);
        setFrequency(filtered[0].frequency);
    };

    const renderSwitch = () => {
        const options = [];
        for (let i = currentYear; i >= startYear; i--) {
            options.push(
                <option value={i} key={i}>
                    {i}
                </option>
            );
        }
        switch (frequency) {
            case "ANNUAL":
                return (
                    <div>
                        {" "}
                        <select
                            className="form-select"
                            required
                            onChange={(e) => {
                                setAnnualYear(e.target.value);
                                getMetricDetails(frequencymonth, metricchoosed);
                            }}
                            value={annualyear}
                        >
                            {options}
                        </select>
                    </div>
                );
            case "FINANCIAL_YEAR":
                options.length = 0;
                for (let i = currentYear; i >= startYear; i--) {
                    options.push(
                        <option value={i} key={i}>
                            {i}(APRIL)
                        </option>
                    );
                }
                return (
                    <div className="row m-0">
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setAnnualYear(e.target.value);
                                    setFrequencyMonth("04");
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={annualyear}
                            >
                                {options}
                            </select>
                        </div>
                    </div>
                );
            case "QUARTERLY":
                return (
                    <div className="row">
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setAnnualYear(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={annualyear}
                            >
                                {options}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setFrequencyMonth(e.target.value);
                                    // setMetricChoosed(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={frequencymonth}
                            >
                                {/* <option value="">{t("Select.label")}</option> */}
                                <option value="01">Q1</option>
                                <option value="04">Q2</option>
                                <option value="07">Q3</option>
                                <option value="10">Q4</option>
                            </select>
                        </div>
                    </div>
                );
            case "HALF_YEARLY":
                return (
                    <div className="row">
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setAnnualYear(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={annualyear}
                            >
                                {options}
                            </select>
                        </div>

                        <div className="col-md-6">
                            <select
                                className="form-select "
                                required
                                onChange={(e) => {
                                    setFrequencyMonth(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={frequencymonth}
                            >
                                <option value="01">JAN-JUN</option>
                                <option value="07">JUL-DEC</option>
                            </select>
                        </div>
                    </div>
                );
            case "MONTHLY":
                return (
                    <div className="row">
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setAnnualYear(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={annualyear}
                            >
                                {options}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <select
                                className="form-select"
                                required
                                onChange={(e) => {
                                    setFrequencyMonth(e.target.value);
                                    getMetricDetails(frequencymonth, metricchoosed);
                                }}
                                value={frequencymonth}
                            >

                                {optionsMonth?.map((items) => (
                                    <option value={items.value} key={items.value}>
                                        {items.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                );
            default:
                return "";
        }
    };

    const updateFieldChanged = (metricDat) => (e) => {
        let data = [...senddatapoints];
        const index = data.findIndex((x) => x.metricId == metricDat.metric.id);
        if (index >= 0) {
            data[index].value = e.target.value;
            setSendDataPoints(data);
        } else {
            let dat = {
                id: metricDat.id,
                value: e.target.value,
                metricId: metricDat.metric.id,
            };
            data.push(dat);
            setSendDataPoints(data);
        }
    };

    const submitDataPoint = async (e) => {
        var objBody = {
            dataPoints: senddatapoints,
        };
        KPIService.saveDataPoint(standardchoosed, frequencyparam, objBody)
            .then((response) => {
                if (response.status === 200) {
                    toast.success("Success", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setIsEditable(false);
                    setSendDataPoints([]);
                    getMetricData(annualyear, frequencymonth);
                }
            })
            .catch((error) => { });
    };

    //   const getTableData = (category, item) => {
    //     switch (category) {
    //       case 'SOCIAL': item.topicCount = socialtabledata.length
    //         return socialtabledata
    //       case 'ENVIRONMENTAL':
    //         item.topicCount = environmenttabledata.length
    //         return environmenttabledata
    //         break;
    //       case 'GOVERNANCE':
    //         item.topicCount = governancetabledata.length
    //         return governancetabledata
    //         break;
    //       default:
    //         break;
    //     }
    //   }

    const handleExpandDs = (e, categoryType) => {
        setDsList([]);
        setCurrentDs([]);
        //setSelDataSource(id);

        const newVal = !shown[categoryType];
        if (newVal) {
            let obj = { categoryType: categoryType };
            setCurrentDs([...currentDs, obj]);
        }
        setShown({
            [categoryType]: !shown[categoryType],
        });

        //  setIsExpanded(true);
    };

    const Environmental_percentage = 72;
    const Social_percentage = 52;
    const Governance_percentage = 42;
    return (
        <div className="RiskAnalytics">
            <div className="List_header">
                <h5 className="MH">{t("Reports.label")}</h5>
            </div>

            <div className="List_Table_01">
                <div className="row m-0 align-items-end justify-content-between">
                    {/* <div className="col-lg-3 p-2 ps-0">
                        <label className="mb-1">
                            {t("Standard.label")} <span className="text-red">*</span>
                        </label>
                        <select
                            className="form-select"
                            value={standardchoosed}
                            onChange={(e) => {
                                changeStandard(e, true);
                            }}
                        >
                            <option value="">{t("Select.label")}</option>
                            {standardslist.map((items) => (
                                <option value={items.id} key={items.id}>
                                    {items.name}
                                </option>
                            ))}
                        </select>
                    </div> */}
                    <div className="col-lg-6 p-0">
                        <div className="row m-0">
                            {standardchoosed && (<div className="col-lg-6 p-2 ps-0">

                                <label className="mb-1">
                                    {t("ReportingPeriod.label")} <span className="text-red">*</span>
                                </label>

                                {renderSwitch()}
                            </div>
                            )}
                            {standardchoosed && (<div className="col-lg-6 p-2">

                                <label className="mb-1">
                                    {t("MetricPeriod.label")} <span className="text-red">*</span>
                                </label>

                                {renderMetric()}
                            </div>
                            )}
                        </div>
                    </div>

                    <div className="col-lg-2 p-2 text-end pe-0">
                        <button
                            type="button"
                            onClick={() => {
                                download();
                            }}
                            className="btn btn-secondary"
                        >
                            <BiExport /> {t("Export.label")}
                        </button>
                    </div>
                </div>
                <div>
                    {renderMetricTable()}
                </div>

                {/* <div className="row m-0">
          <div className="col-lg-3 p-2 ps-0">
            <div className="card Select_Standard_choose_box">
              <div className="card-body">
                <h6 className="m-0">Environmental</h6>
                <div className="">
                  <CircularProgressbar value={Environmental_percentage} text={`${Environmental_percentage}%`} strokeWidth={8} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 p-2 ps-0">
            <div className="card Select_Standard_choose_box">
              <div className="card-body">
                <h6 className="m-0">Social</h6>
                <div className="">
                  <CircularProgressbar value={Social_percentage} text={`${Social_percentage}%`} strokeWidth={8} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 p-2 ps-0">
            <div className="card Select_Standard_choose_box">
              <div className="card-body">
                <h6 className="m-0">Governance</h6>
                <div className="">
                  <CircularProgressbar value={Governance_percentage} text={`${Governance_percentage}%`} strokeWidth={8} />
                </div>
              </div>
            </div>
          </div>
        </div> */}
                {maintabledata.length > 0 && <div>
                    {categorydata?.map((item, index) => {
                        return (
                            <div>

                            </div>
                        );
                    })}
                </div>}

            </div>

            {/* <Modal show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Form>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
              <div className="p-2">
                  <label className="mb-1">{t("SubscriptionPlan.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={planname}
                    required
                    onChange={(e) => setPlanName(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Regulation.label")} <span className='text-red'>*</span></label>
                  <Multiselect
                    options={regulations}
                    selectedValues={regulationsubmitarray}
                    onSelect={onSelectRegulation}
                    onRemove={onRemoveRegulation}
                    displayValue="name"
                  />
                </div>
                
                <div className="p-2">
                  <label className="mb-1">{t("NumberOfUsers.label")} <span className='text-red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={numberofuser}
                    required
                    onChange={(e) => setNumberOfUser(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("Status.label")} <span className='text-red'>*</span></label>
                  <select className="form-select" value={editstatusvalue} onChange={(e) => setEditStatusvalue(e.target.value)}>
                    <option value={true}>{t("Active.label")}</option>
                    <option value={false}>{t("Inactive.label")}</option>
                  </select>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          <Button variant="primary" onClick={handleSubmit} className="sbmBtn">
            {t("Create.label")}
          </Button>

        </Modal.Footer>
      </Modal> */}
        </div >
    );
};

export default withTranslation()(RiskAnalytics);
